import React, { useEffect, useState, useRef, useCallback } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withStyles, Slide } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import {
  PhotoCamera,
  CloudUpload,
  CheckCircleOutline,
  Close,
  Replay,
  Check,
} from "@material-ui/icons";
import Webcam from "react-webcam";
import { getBase64 } from "../../utils/tools";
import { images } from "../../utils/images";

function IdentityVerification(props) {
  const { classes, t } = props;
  const webcamRef = useRef(null);
  const [method, setMethod] = useState(null);
  const [cameraReady, setCameraReady] = useState(false);
  const [photo, setPhoto] = useState("");
  const [photoUploaded, setPhotoUploaded] = useState({
    photoUrl: "",
    file: null,
  });
  const [cameraAllowed, setCameraAllowed] = useState(true);

  // No Camera Permission
  const handleNoCameraPermission = () => {
    setCameraAllowed(false);
  };

  // Capture Photo
  const capturePhoto = useCallback(() => {
    let cam = document.getElementsByTagName("video");

    const imageSrc = webcamRef.current.getScreenshot({
      height: cam[0].offsetHeight * 4,
      width: cam[0].offsetWidth * 4,
    });
    setPhoto(imageSrc);
  }, [webcamRef]);

  // Retake Photo
  const retakePhoto = () => {
    setPhoto("");
  };

  // Confirm Photo Take
  const confirmPhoto = () => {
    props.addSelfie(photo);
    props.moveForward(true);
  };

  // Handle Image Uplaoded
  const imageUploaded = (file) => {
    let acceptedTypes = ["image/png", "image/jpeg", "image/jpg"];
    if (!acceptedTypes.includes(file.type)) {
      props.pushNotification({ message: "_invalidFileType", type: "error" });
      return;
    }

    if (file.size > 10485760) {
      props.pushNotification({ message: "_fileTooBig", type: "error" });
      return;
    }

    const photo = URL.createObjectURL(file);
    setPhotoUploaded({ photoUrl: photo, file: file });
  };

  // Create File Input Selector
  const createFileSelector = () => {
    const fileSelector = document.createElement("input");
    fileSelector.setAttribute("type", "file");
    fileSelector.setAttribute("accept", ".png, .jpg");
    fileSelector.addEventListener(
      "change",
      function (e) {
        imageUploaded(e.target.files[0]);
      },
      false
    );
    return fileSelector;
  };
  const fileInput = createFileSelector();

  // Browse Files
  const browseFiles = () => {
    fileInput.click();
  };

  // Remove Uploaded Photo
  const removeUploadedPhoto = () => {
    setPhotoUploaded({ photoUrl: "", file: null });
    fileInput.value = "";
  };

  // Confirm Uploaded Photo
  const confirmPhotoUploaded = async () => {
    let base64 = await getBase64(photoUploaded.file);
    props.addSelfie(base64);
    props.moveForward(true);
  };

  // Handle file drop
  const handleDrop = (ev) => {
    ev.preventDefault();

    if (ev.dataTransfer.items) {
      //   // Use DataTransferItemList interface to access the file(s)
      for (var i = 0; i < ev.dataTransfer.items.length; i++) {
        // If dropped items aren't files, reject them
        if (ev.dataTransfer.items[i].kind === "file") {
          var file = ev.dataTransfer.items[i].getAsFile();
          imageUploaded(file);
        }
      }
    } else {
      // Use DataTransfer interface to access the file(s)
      for (var i = 0; i < ev.dataTransfer.files.length; i++) {
        imageUploaded(ev.dataTransfer.files[i]);
      }
    }
  };

  return (
    <Slide in direction="left">
      <div className={classes.container}>
        <div className="stepBody">
          <div className="left">
            <h2 dangerouslySetInnerHTML={{ __html: t("verifyIdentity") }} />
            <p className="subtitle">{t("verifySubtitle")}</p>
            <ul>
              <li>{t("verifyRequirements1")}</li>
              <li>{t("verifyRequirements2")}</li>
            </ul>
            <div className="photoMethods">
              <div
                className={`btnOption ${
                  method === "camera" ? "activemethod" : ""
                }`}
                onClick={() => setMethod("camera")}
              >
                <p>{t("takePhoto")}</p>
                {method === "camera" ? (
                  <img src={images.icons.cameraWhite} />
                ) : (
                  <img src={images.icons.camera} />
                )}
              </div>
              <div
                className={`btnOption ${
                  method === "upload" ? "activemethod" : ""
                }`}
                onClick={() => setMethod("upload")}
              >
                <p>{t("uploadFile")}</p>
                {method === "upload" ? (
                  <img src={images.icons.uploadWhite} />
                ) : (
                  <img src={images.icons.upload} />
                )}
              </div>
            </div>
            {cameraAllowed ? (
              ""
            ) : (
              <p className={classes.cameraNotAllowed}>{t("pleaseAllow")}</p>
            )}
          </div>
          <div className="right">
            {method === "camera" ? (
              photo === "" ? (
                <Webcam
                  audio={false}
                  width={"100%"}
                  // width={1920}
                  // height={1080}
                  ref={webcamRef}
                  screenshotFormat="image/png"
                  screenshotQuality={1}
                  style={{
                    border: "2px solid black",
                    borderRadius: 2,
                  }}
                  onUserMedia={() => setCameraReady(true)}
                  onUserMediaError={(e) => handleNoCameraPermission()}
                />
              ) : (
                <img
                  src={photo}
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "contain",
                  }}
                />
              )
            ) : (
              ""
            )}
            {method === "camera" ? (
              <div className="cameraButtons">
                {photo === "" ? (
                  <div className="photoBtnWrapper">
                    <div
                      className="takePhotoBtn"
                      onClick={
                        cameraAllowed && cameraReady
                          ? () => capturePhoto()
                          : () => {}
                      }
                    />
                  </div>
                ) : (
                  <div className="takenBtnWrapper">
                    <button onClick={() => retakePhoto()}>
                      {t("retakePhoto")}
                      <Replay />
                    </button>
                    <button
                      className="confirmBtn"
                      onClick={() => confirmPhoto()}
                    >
                      {t("confirm")}
                      <Check />
                    </button>
                  </div>
                )}
              </div>
            ) : (
              ""
            )}
            {method === "upload" ? (
              <div
                onClick={
                  photoUploaded.file !== null ? () => {} : () => browseFiles()
                }
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => handleDrop(e)}
                className={`rightBody uploadContainer ${
                  photoUploaded.photoUrl === "" ? "" : "photoUploaded"
                }`}
              >
                {photoUploaded.photoUrl === "" ? (
                  <CloudUpload classes={{ root: classes.cloud }} />
                ) : (
                  // <img src={photoUploaded.photoUrl} />
                  <div className={classes.successUpload}>
                    <CheckCircleOutline />
                    <p>{t("_successUpload")}</p>
                    <p className="remove" onClick={() => removeUploadedPhoto()}>
                      {t("delete")} <Close classes={{ root: classes.close }} />
                    </p>
                  </div>
                )}

                {photoUploaded.photoUrl === "" ? (
                  <div className={classes.dragBtn}>
                    <p>{t("dragAndDrop")}</p>
                    <h3>{t("_or")}</h3>
                    <button className="uploadBtn">{t("browseFiles")}</button>
                  </div>
                ) : (
                  <div className="uploadedPhotoBtns">
                    <button
                      className="confirmBtn"
                      onClick={() => confirmPhotoUploaded()}
                    >
                      {t("confirm")}
                    </button>
                  </div>
                )}
              </div>
            ) : (
              ""
            )}

            {method === null ? (
              <img
                style={{ width: "100%", height: "auto", objectFit: "contain" }}
                src={images.illustrations.idIllustrationSolo}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </Slide>
  );
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

const styles = (theme) => ({
  dragBtn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "& h3": {
      fontSize: 18,
      // fontFamily: "Titillium Web",
      fontWeight: 600,
      marginTop: 16,
      marginBottom: 16,
    },
  },
  cameraNotAllowed: {
    color: theme.colors.buttons.sell,
    marginTop: 16,
    // fontFamily: "Titillium Web",
    lineHeight: "21px",
    fontSize: 14,
  },
  container: {
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    background: theme.colors.background.fore,
    boxShadow: theme.defaults.shadow,
    maxWidth: 880,
    width: "90%",
    padding: 40,
    color: theme.colors.text.primary,

    [theme.breakpoints.down(500)]: {
      padding: 24,
    },

    "& .stepBody": {
      display: "flex",
      width: "100%",
      justifyContent: "space-between",

      "& .left": {
        width: "50%",
        position: "relative",
        "& h2": {
          fontSize: 28,
          fontWeight: 300,
          marginBottom: 48,
          "& b": {
            fontWeight: 600,
          },
        },

        "& .subtitle": {
          fontSize: 14,
          color: theme.colors.text.secondary,
          marginTop: 8,
          marginBottom: 24,
        },

        "& ul": {
          marginLeft: 20,
          marginTop: 16,
          "& li": {
            fontSize: 16,
            listStyleType: "disc",
            color: theme.colors.text.primary,
            marginTop: 8,
          },
        },

        "& .photoMethods": {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          margin: "24px auto 0",
          [theme.breakpoints.down(500)]: {
            flexDirection: "column",
          },
          "& .btnOption": {
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            transition: ".3s",
            textAlign: "center",
            justifyContent: "space-between",
            width: "47.5%",
            padding: 16,
            background: theme.colors.background.lightFore,
            "&.activemethod": {
              background: theme.colors.misc.activeDoc,
              color: theme.colors.text.textOnRed,
            },
            [theme.breakpoints.down(500)]: {
              width: "100%",
              marginBottom: 8,
            },
            "& img": {
              width: 25,
              height: "auto",
            },

            "&:hover": {
              color: theme.colors.text.secondary,
            },
          },
        },

        "& button": theme.defaults.roundBtn,
        "& .confirmBtn": {
          background: theme.colors.buttons.green,
          marginTop: 32,
          float: "right",
        },
      },
      "& .right": {
        width: "45%",

        "& .cameraButtons": {
          display: "flex",
          justifyContent: "center",
          height: 57,
          alignItems: "center",
          marginTop: -2,
          background: theme.colors.misc.dividers,

          "& .photoBtnWrapper": {
            height: 38,
            width: 38,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "50%",
            border: `2px solid ${theme.colors.background.fore}`,
            "& .takePhotoBtn": {
              height: 32,
              width: 32,
              borderRadius: "50%",
              cursor: "pointer",
              transition: ".3s",
              background: theme.colors.background.fore,
              "&:hover": {
                opacity: 0.3,
              },
            },
          },
          "& .takenBtnWrapper": {
            width: "75%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",

            "& button": {
              ...theme.defaults.roundBtn,
              background: "none",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",

              "& svg": {
                marginLeft: 4,
              },
            },
          },
        },

        "& .uploadContainer": {
          width: "100%",
          height: 400,
          border: `2px dashed ${theme.colors.misc.dividers}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          cursor: "pointer",

          "&.photoUploaded": {
            borderColor: "transparent",
          },
          "& img": {
            width: "70%",
            height: "auto",
            marginBottom: 16,
          },
          "& button": theme.defaults.roundBtn,
          "& .uploadBtn": {
            background: "transparent",
            color: theme.colors.buttons.green,
            borderColor: theme.colors.buttons.green,
            fontSize: 14,
            textTransform: "capitalize",
          },

          "& svg": {
            cursor: "pointer",
            fontSize: 160,
          },
          "& .uploadedPhotoBtns": {
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "auto",
            width: "100%",
            "& button": {
              color: theme.colors.misc.black,
            },
            "& .confirmBtn": {
              background: theme.colors.buttons.green,
              marginLeft: 8,
              color: theme.colors.text.primary,
            },
          },
        },
      },
      [theme.breakpoints.down(700)]: {
        flexDirection: "column",
        "& .left, & .right": {
          width: "100%",
        },
        "& .right": {
          marginTop: 24,
        },
      },
    },
  },
  successUpload: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "& svg": {
      fontSize: 160,
      color: theme.colors.buttons.green,
      marginBottom: 24,
    },
    "& p": {
      fontSize: 18,
      // fontFamily: "Titillium Web",
      fontWeight: 500,
    },
    "& .remove": {
      background: theme.colors.background.inactive,
      display: "flex",
      height: 30,
      padding: "0 16px",
      cursor: "pointer",
      fontWeight: 400,
      borderRadius: 40,
      alignItems: "center",
      marginTop: 12,
      "& svg": {
        fontSize: 20,
        marginLeft: 16,
        color: theme.colors.text.primary,
        margin: 0,
      },
    },
  },
  close: {
    fontSize: "18px !important",
  },
  cloud: {
    fontSize: "80px !important",
  },
});

export default withStyles(styles)(
  withTranslation()(
    connect(mapStateToProps, mapDispatchToProps)(IdentityVerification)
  )
);
